import {
  calculateItemTotal,
  calculateTotal,
  calculateVatTotal,
  findBiggestApplicableVolumeDiscounts,
} from "@sellar-io/common";
import type { BasketOrderItem } from "../../../hooks";
import { isPromotionalOrderItem } from "../../stockList/categoryPage/Storefront/StorefrontPromotion/isPromotionalOrderItem";
import type { SupplierStorefrontInfo } from "../UnifiedCheckoutProvider.shared";

export const calculateUnifiedCheckoutOrderPricing = ({
  orderItems,
  storefront,
  vatPercentage,
}: {
  orderItems: BasketOrderItem[];
  storefront: SupplierStorefrontInfo["storefront"] | null | undefined;
  vatPercentage: number;
}) => {
  const subtotal = calculateItemTotal(orderItems);
  const appliedVolumeDiscounts = findBiggestApplicableVolumeDiscounts({
    volumeDiscountList: storefront?.VolumeDiscounts?.PriceTierDiscounts ?? [],
    caseSizeRuleList: storefront?.CaseSizeRules.list ?? [],
    orderItemList: orderItems
      .filter((item) => !isPromotionalOrderItem(item))
      .map((item) => ({
        quantity: item.quantity,
        volume: item.Product.volume ?? null,
        unit: item.Product.unit ?? null,
        packQuantity: item.Product.packQuantity ?? null,
        containerType: item.Product.containerType ?? null,
        price: item.price,
        discountable: item.discountable,
      })),
  }).filter(({ discountAmount }) => discountAmount > 0);
  const discount = appliedVolumeDiscounts.reduce(
    (total, result) => total + result.discountAmount,
    0,
  );
  const orderPricing = {
    orderItems,
    deliveryCharge: 0,
    discountAmount: discount,
    vatPercentage,
  };

  return {
    subtotal,
    discount,
    appliedVolumeDiscounts,
    vat: calculateVatTotal(orderPricing),
    total: calculateTotal(orderPricing),
  };
};
